import React from "react";
import { getBrandLogoByName } from "../../../helpers/brandLogos";

const BrandLogo = ({ brandName, showName = false }) => {
  const brandLogoKey = getBrandLogoByName(brandName);

  return (
    <div className="d-flex align-items-center" style={{ gap: 5 }}>
      <span className="p-1 bg-white rounded-circle d-inline-flex align-items-center justify-content-center border shadow-sm">
        <i className={`car-${brandLogoKey} brand-logo mr-0`}></i>
      </span>
      {showName && <span className="brand-logo-name">{brandName}</span>}
    </div>
  );
};

export default BrandLogo;
